exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formaProfit_box[data-v-79a2acd4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:12px}.formaProfit_box .color_txt[data-v-79a2acd4]{color:#2828ff;font-size:13px}.formaProfit_box .red_txt[data-v-79a2acd4]{color:#e00707}.formaProfit_box .order_title[data-v-79a2acd4]{color:#000;font-weight:700}", ""]);

// exports
